import React from "react";
import { useParams } from "react-router";
import {
	useCurrentProfileInitialization,
	useIsAdmin,
	useIsLearner,
	useRegisterState,
} from "@domain/currentProfile/hooks";
import { InitializationState } from "@domain/currentProfile/initializationState";
import { NotFoundPage } from "@ui/pages/notFoundPage";
import { Redirect } from "./redirect";
import { Path } from "./path";

interface RequireAuthProps {
	admin?: boolean;
	guest?: React.ReactNode;
	children: React.ReactNode;
}

export const RequireAuth: React.FC<RequireAuthProps> = ({ guest, admin, children }) => {
	const initialization = useCurrentProfileInitialization();
	const registerState = useRegisterState();
	const isAdmin = useIsAdmin();

	if (initialization === InitializationState.PENDING) {
		return null;
	}

	if (admin && registerState === "FINISHED" && !isAdmin) {
		return <NotFoundPage />;
	}

	if (registerState !== "FINISHED") {
		if (guest) {
			return <>{guest}</>;
		}
		return <Redirect to={{ pathname: Path.Root }} />;
	}

	return <>{children}</>;
};

/** Blocks learner access to content creation routes (`id` or `liveId` equal to `new`). Editing an existing item stays open. */
export const BlockLearnerCreation: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const params = useParams();
	const isLearner = useIsLearner();
	const creating = params.id === "new" || params.liveId === "new";

	if (isLearner && creating) {
		return <Redirect to={{ pathname: Path.Root }} />;
	}

	return <>{children}</>;
};
